<form
    class="entry-page-form"
    [formGroup]="form"
    (ngSubmit)="onSubmit(form.value, $event)"
    novalidate
    autocomplete="off"
>
    <div *ngIf="profile_id">
        <ng-container *ngIf="roleId !== ROLE_CODES.PROFESSIONAL; else professionalTitle">
            <h3 class="title">
                Please provide some additional<br />
                information for your {{ headlineRoleTitle }} profile
            </h3>
        </ng-container>

        <ng-container> </ng-container>

        <cm-external-login-icons *ngIf="!showExternalLogin" [signInType]="loginType" [settings$]="settings$">
        </cm-external-login-icons>

        <div class="form-group">
            <label class="form-label">Organization:</label>
            <input
                type="text"
                class="form-control"
                [ngClass]="{ 'is-invalid': form.controls.organization.errors && submitted }"
                formControlName="organization"
            />
        </div>

        <div class="form-group">
            <label class="form-label"> {{ profileTypeId === PROFILE_TYPE_ID.FACILITY ? 'Name' : 'First name' }}:</label>
            <input
                type="text"
                class="form-control"
                [ngClass]="{ 'is-invalid': form.controls.first_name.errors && submitted }"
                formControlName="first_name"
            />
        </div>

        <div class="form-group" *ngIf="profileTypeId === PROFILE_TYPE_ID.INDIVIDUAL">
            <label class="form-label">Last name:</label>
            <input
                type="text"
                class="form-control"
                [ngClass]="{ 'is-invalid': form.controls.last_name.errors && submitted }"
                formControlName="last_name"
            />
        </div>

        <div class="form-group">
            <label class="form-label">Email:</label>
            <input
                type="email"
                class="form-control"
                [ngClass]="{ 'is-invalid': form.controls.email.errors && submitted }"
                formControlName="email"
            />
        </div>

        <div *ngIf="showPasswords">
            <div class="form-group" [hidden]="activated">
                <label class="form-label">Password:</label>
                <input
                    type="password"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': form.controls.password.errors && submitted }"
                    formControlName="password"
                />
            </div>

            <div class="form-group" [hidden]="activated">
                <label class="form-label">Confirm Password:</label>
                <input
                    type="password"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': form.controls.confirm_password.errors && submitted }"
                    formControlName="confirm_password"
                />
            </div>
        </div>

        <cm-invite-location-block
            *ngIf="locationData"
            [form]="form"
            [locations]="locations"
            [profile]="locationData"
            [disabled]="true"
            [organizationLabels]="organizationsLabel"
        ></cm-invite-location-block>

        <div class="form-group" *ngIf="organizationRoles.length">
            <label class="form-label">Role:</label>
            <cm-select
                class="form-control inner-component"
                [options]="organizationRoles"
                formControlName="organizationRoleId"
            >
            </cm-select>
        </div>

        <div class="form-group terms-conditions">
            <input
                type="checkbox"
                id="termCheckbox"
                class="ch-checkbox"
                [checked]="isTermsAndCondAccepted"
                (change)="isTermsAndCondAccepted = !isTermsAndCondAccepted"
            />
            <label for="termCheckbox" class="ch-checkbox-label">
                I accept
                <a class="cm-link" [routerLink]="['/terms-and-conditions']" target="_blank">Terms & Conditions</a>
            </label>
        </div>
    </div>

    <div class="login-buttons">
        <button *ngIf="profile_id" class="btn ch-button" type="submit" [disabled]="disabled">Continue</button>
        <cm-iframe-external-login
            *ngIf="showExternalLogin"
            [settings]="settings$ | async"
            (callback)="handleCredentialResponse($event)"
        >
        </cm-iframe-external-login>
    </div>
    <cm-inline-error
        class="mt-2 inline-error"
        *ngIf="errorsMessages"
        [errorMessages]="errorsMessages"
    ></cm-inline-error>
</form>
<ng-template #professionalTitle>
    <h3 class="title">Please provide some additional information necessary for you to access your Certemy account</h3>
    <p class="entry-description">
        Please note that we use the Certemy platform to manage our certification and compliance programs. This is a
        separate platform that requires its own username (email) and password.
    </p>
</ng-template>
